import { render, staticRenderFns } from "./DxDetailTabsBatches.vue?vue&type=template&id=053b857c&scoped=true&"
import script from "./DxDetailTabsBatches.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabsBatches.vue?vue&type=script&lang=js&"
import style0 from "./DxDetailTabsBatches.vue?vue&type=style&index=0&id=053b857c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053b857c",
  null
  
)

export default component.exports